import BattlePlayer from 'models/battles/BattlePlayer';

/**
 * Splits battle players into the logged in user and their opponent.
 *
 * Prefers the `is_opponent` flag from the API (returned by battle details and start battle).
 * The my-kpi-battles list does not send it, so there we fall back to matching by user id.
 */
export const resolveBattleSides = (players: BattlePlayer[], currentUserId?: string) => {
	const hasOpponentFlag = players.some(player => player.isOpponent !== undefined);

	return hasOpponentFlag
		? {
				currentPlayer: players.find(player => player.isOpponent === false),
				opponent: players.find(player => player.isOpponent === true),
		  }
		: {
				currentPlayer: players.find(player => player.userId === currentUserId),
				opponent: players.find(player => player.userId !== currentUserId),
		  };
};
